import { httpClient } from './http-client';

export interface MemedSyncStatus {
  isLinked: boolean;
  syncStatus: 'NOT_LINKED' | 'PENDING' | 'SYNCING' | 'LINKED' | 'FAILED';
  prescriberId?: string;
  lastSyncAt?: string;
  lastError?: string;
}

export interface MemedLinkResult {
  success: boolean;
  prescriberId: string;
  token: string;
  isExisting: boolean;
  message: string;
}

export interface SyncMemedPrescriptionDto {
  appointmentId?: string;
  medicalRecordId?: string;
  patientId: string;
  doctorId?: string;
  memedPrescriptionId: string;
  medications?: any[];
  digitalPrescriptionLink?: string;
  unlockCode?: string;
  doctorToken?: string;
}

export interface DigitalPrescriptionLinkResponse {
  link: string;
  unlockCode: string;
}

export const memedApi = {
  syncPrescription: (payload: SyncMemedPrescriptionDto) =>
    httpClient.post<any>('/medical-records/prescriptions/sync-memed', payload),
  syncMemedPrescription: (payload: SyncMemedPrescriptionDto) =>
    httpClient.post<any>('/medical-records/prescriptions/sync-memed', payload),
  syncMemedCertificate: (payload: any) =>
    httpClient.post<any>('/medical-records/certificates/sync-memed', payload),
  syncMemedExam: (payload: any) =>
    httpClient.post<any>('/medical-records/exams/sync-memed', payload),
  getDigitalPrescriptionLink: (prescriptionId: string) =>
    httpClient.get<DigitalPrescriptionLinkResponse>(`/medical-records/prescriptions/${prescriptionId}/digital-link`),
  sendToMemed: (prescriptionId: string) =>
    httpClient.post(`/medical-records/prescription/${prescriptionId}/send-to-memed`),
  getStatus: (prescriptionId: string) =>
    httpClient.get(`/medical-records/prescription/${prescriptionId}/memed-status`),
  downloadPdf: (prescriptionId: string) =>
    httpClient.get(`/medical-records/prescription/${prescriptionId}/pdf`),

  sendCertificateToMemed: (certificateId: string) =>
    httpClient.post(`/medical-records/certificate/${certificateId}/send-to-memed`),
  getCertificateStatus: (certificateId: string) =>
    httpClient.get(`/medical-records/certificate/${certificateId}/memed-status`),
  downloadCertificatePdf: (certificateId: string) =>
    httpClient.get(`/medical-records/certificate/${certificateId}/pdf`),

  sendExamToMemed: (examId: string) =>
    httpClient.post(`/medical-records/exam-request/${examId}/send-to-memed`),
  getExamStatus: (examId: string) =>
    httpClient.get(`/medical-records/exam-request/${examId}/memed-status`),

  getIntegrationStatus: (): Promise<MemedSyncStatus> =>
    httpClient.get<MemedSyncStatus>('/integrations/memed/status'),

  linkDoctor: (): Promise<MemedLinkResult> =>
    httpClient.post<MemedLinkResult>('/integrations/memed/link'),

  syncDoctor: (): Promise<MemedSyncStatus> =>
    httpClient.post<MemedSyncStatus>('/integrations/memed/sync'),

  getToken: (): Promise<{ token: string }> =>
    httpClient.get<{ token: string }>('/integrations/memed/token'),

  getProtocols: (cid?: string): Promise<any[]> =>
    httpClient.get<any[]>(cid ? `/memed/protocolos?cid=${encodeURIComponent(cid)}` : '/memed/protocolos'),
};
